import { FC } from "react";

import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, IToken } from "@framework/types";
import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import ERC721WrapperUnpackABI from "@framework/abis/json/ERC721Wrapper/unpack.json";

export interface IWrapperUnpackButtonProps {
  className?: string;
  disabled?: boolean;
  token: IToken;
  variant?: ListActionVariant;
}

export const WrapperUnpackButton: FC<IWrapperUnpackButtonProps> = props => {
  const { className, disabled, token, variant = ListActionVariant.button } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFn } = useMetamask(async (token: IToken) => {
    return writeContractAsync({
      address: token.template!.contract!.address as AddressType,
      abi: ERC721WrapperUnpackABI,
      functionName: "unpack",
      args: [token.tokenId],
    });
  });

  const handleUnpack = (token: IToken): (() => Promise<void>) => {
    return async (): Promise<void> => {
      return metaFn(token).then(() => {
        // TODO reload page
        return;
      });
    };
  };

  return (
    <ListAction
      onClick={handleUnpack(token)}
      message="form.buttons.unpack"
      className={className}
      dataTestId="WrapperUnpackButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
